<template>
  <section
    id="cover"
    class="te-bg-ai-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faHeadSideBrain"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      AIコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      AI（人工知能）の構築に必要な機械学習・ディープラーニングを習得
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        AI(人工知能)を学習・勉強して短期間でAI(人工
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >知能)の構築に必要な機械学習・ディープラーニングを学べる講座。Pythonのライブラリを使い、機械学習の応用までを実践的に学ぶことができます。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでサポート。転職サポートもあり。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>

    <!-- 経済産業省認定バッジ -->
    <TeCommonBadgeReskilling />
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import TeCommonBadgeReskilling from '~/components/Te/TeCommon/Badge/Reskilling/TeCommonBadgeReskilling.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHeadSideBrain } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faHeadSideBrain,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    TeCommonBadgeReskilling,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-ai-image {
  height: 560px;
  background-image: linear-gradient(
      to top,
      rgba(0, 97, 106, 0.75),
      rgba(0, 191, 208, 0.75)
    ),
    url('~/assets/images/Te/TeCourse/Ai/Cover/ai.jpg');
  @media (min-width: 576px) {
    height: 600px;
  }
  @media (min-width: 768px) {
    height: 500px;
  }
}
</style>
